<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="preface">
<h1>Preface</h1>
<p>Life is a story told in hundreds of moments of laughter, pain, joy, and love – experiences that wrap together and create a person, with all the resident emotions that evolve from simply living.</p>
<p>My story is as random as everyone’s – a myriad of puzzle pieces that only occasionally truly fit together, and paint only a glimpse into the complexities that are the human part of each of us.</p>
<p>This book is semi-autobiographical – partly word pictures that stroll through periods of my life, and then it is often random thoughts or images from momentary observations of daily life events. All of them are pages from the notes inside a random mind.</p>
<p>I tried to gather my thoughts in chapters that had some continuity, which only made me realize that only fragments of your life have continuity. Certainly, our experiences growing up have a continuum, and falling in love could be semi-charted – Beginnings of looking, losing (maybe several times), and finally finding that right one.</p>
<p>But most of the rest of our lives are much more random. No one knows how long a chapter might be, or when one chapter ends and another begins. No one anticipates tragedy or facing death – man lives on hope, and not on planning for the worst – but tragedy and facing survival changes a lot of perspectives. And sometimes, thoughts are just too random to fit in any specific place.</p>
<p>Even when life semi-sorts itself out, when right people happen, when some stability seems to impose itself, random events and thoughts and moments still find time to sneak in through the cracks, to remind you that no matter what we believe, life is a collection of random moments.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?2620c6b5